import TextInput from "@builder/components/general/TextInput";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect, useState } from "react";

const SetProductAsActive = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const [skuInput, setSkuInput] = useState<string | null>(actionStep?.action?.data.sku || null);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const action = {
            type: ActionType.SET_PRODUCT_ACTIVE,
            data: { sku: skuInput }
        };
        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id, item: updatedStep as ActionEditorItem }));
        }
    }, [actionStep, dispatch, id, skuInput]);

    return (
        <div className="function-add-cart-note-wrapper">
            <div className="function-add-cart-note">
                <TextInput title="" callback={setSkuInput} value={skuInput || ""} className="actions-tab-input" placeholder="Enter product SKU" />
            </div>
        </div>
    );
};

export default SetProductAsActive;
